import React from "react";
import { Link } from "react-router-dom";

import "../../css/footer.css";
import blackLogo from "../../images/blacklogo.PNG";
import { IotUrl } from "../../Shared";
const Footer = () => {
	return (
		<div className="footer">
			{/* <div className="copyright">
        <p style={{visibility :'hidden'}}>
          Copyright © Designed &amp; Developed by{" "}
          <a href="http://dexignzone.com/" target="_blank"  rel="noreferrer">
            DexignZone
          </a>{" "}
          2021
        </p>
      </div> */}
			<div className="copyright">
				{/* <div className="logo-text">
          <img
            style={{ cursor: "pointer" }}
            onClick={() => window.open("https://nitro.network")}
            src="https://ecosystem.nitro.network/static/media/Logo.2a3c7d4a.png"
            alt=""
          />
          <p>
            Nitro Network is building the largest decentralized private
            communication network powered by IoT combined with LoRaWAN and
            3G/4G/5G. This hyperconnected world will enable unlimited use cases
            in our everyday life. Participants of Nitro’s decentralized PCN are
            part of an inclusive ecosystem that they own, operate and earn from.
            Nitro’s PCN will be a game-changer and has its proprietary token,
            $NCash, at its core. On Nitro Network, everybody wins!
          </p>
        </div> */}

				<div className="about-links">
					<div className="logo-text">
						<Link to="/dashboard">
							<img
								style={{ cursor: "pointer", maxWidth: "180px" }}
								// onClick={() => window.open("https://nitro.network")}
								//   src="https://ecosystem.nitro.network/static/media/Logo.2a3c7d4a.png"
								src={blackLogo}
								alt=""
							/>
						</Link>
						<p>
							Nitro Network is building the largest decentralized private
							communication network powered by IoT combined with LoRaWAN and
							3G/4G/5G. This hyperconnected world will enable unlimited use
							cases in our everyday life. Participants of Nitro’s decentralized
							PCN are part of an inclusive ecosystem that they own, operate and
							earn from. Nitro’s PCN will be a game-changer and has its
							proprietary token, $NCash, at its core. On Nitro Network,
							everybody wins!
						</p>
					</div>

					<div className="links">
						<h4>GET TO KNOW US </h4>
						<p>
							<a
								href="https://docs.nitro.network/"
								target="_blank"
								rel="noopener noreferrer"
							>
								DOCUMENTATION
							</a>
						</p>
						{/* <p>
              <a
                href="https://nitro.network/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                TERMS & CONDITIONS
              </a>
            </p> */}
						<p>
							<Link
								to="/terms-and-conditions"
								target="_blank"
								rel="noopener noreferrer"
							>
								TERMS & CONDITIONS
							</Link>
						</p>
						<p>
							<Link
								to="/pre-order-agreement-and-privacy-policy"
								target="_blank"
								rel="noopener noreferrer"
							>
								PREORDER AGREEMENT
							</Link>
						</p>
						{/* <p>
              <a
                href="https://nitro.network/pre-order-agreement-and-privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                PREORDER AGREEMENT
              </a>
            </p> */}
						<p>
							<a
								href="https://docsend.com/view/pn69hwzgi8hfqs8m"
								target="_blank"
								rel="noopener noreferrer"
							>
								LITEPAPER
							</a>
						</p>
						<p>
							<a
								href="https://docsend.com/view/69wukxyj6vin9bvy"
								target="_blank"
								rel="noopener noreferrer"
							>
								WHITEPAPER
							</a>
						</p>
						<p>
							<a href={IotUrl} target="_blank" rel="noopener noreferrer">
								RESOURCES
							</a>
						</p>
					</div>
				</div>
				<div className="contact-footer">
					<h3>CONTACT US</h3>
					<p>
						Email:
						<span className="green">
							<a href="mailto:info@nitro.network">info@nitro.network</a>
						</span>
					</p>

					<div className="social-icons">
						<p>
							<a
								href="https://www.facebook.com/NitroNetworkHQ/"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-facebook fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://www.instagram.com/nitro_hq/"
								target="_blank"
								rel="noreferrer"
							>
								{/* <i className="fa-brands fa-instagram-square"></i> */}
								<i className="fab fa-instagram-square fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://www.linkedin.com/company/nitronetwork"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-linkedin fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://twitter.com/Nitro_HQ"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-twitter fa-lg"></i>
							</a>
						</p>

						<p>
							<a
								href="https://nitronetwork.medium.com/"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-medium fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://www.reddit.com/r/NucleusVision/"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-reddit fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://t.me/NucleusVision_ann"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-telegram fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://www.youtube.com/channel/UCJ4LIGyMee0HnAx4rDvX0nw"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-youtube fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://discord.com/invite/8kQknUCFHs"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-discord fa-lg"></i>
							</a>
						</p>
						<p>
							<a
								href="https://github.com/nucleusvision"
								target="_blank"
								rel="noreferrer"
							>
								<i className="fab fa-git-square fa-lg"></i>
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
